import z from 'zod';
import { scopedEntity, anyPolygonGeometry, assetRef, string, } from '../common';
import { staticResponderRelation } from './staticResponder';
export var ZoneType;
(function (ZoneType) {
    ZoneType["Default"] = "default";
    ZoneType["ResponseArea"] = "responseArea";
    ZoneType["PoliceDepartment"] = "policeDepartment";
    ZoneType["AssetMonitoredArea"] = "assetMonitoredArea";
    ZoneType["Fingerprinted"] = "fingerprinted";
})(ZoneType || (ZoneType = {}));
export const zone = z.object({
    ...scopedEntity.shape,
    type: z.nativeEnum(ZoneType),
    location: anyPolygonGeometry,
    name: string,
    description: string.nullable().default(null),
    staticResponders: staticResponderRelation.array().default([]),
    responsePriority: z.number().nullable().default(null),
    assetsInside: assetRef.array(),
    syncToAms: z.boolean().optional(),
});
